/**
 * @generated SignedSource<<55ccb8f7e7878747eb591111ee0e6e0a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type moduleRating_Query$variables = {
  nodeRef: string;
};
export type moduleRating_Query$data = {
  readonly ModuleRating: {
    readonly GetModuleRatingOptByNodeAndUserRef: {
      readonly id: string;
      readonly value: number;
    } | null;
  };
};
export type moduleRating_Query = {
  response: moduleRating_Query$data;
  variables: moduleRating_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "nodeRef"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ModuleRatingQueries",
    "kind": "LinkedField",
    "name": "ModuleRating",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "nodeRef",
            "variableName": "nodeRef"
          }
        ],
        "concreteType": "ModuleRating",
        "kind": "LinkedField",
        "name": "GetModuleRatingOptByNodeAndUserRef",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "value",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "moduleRating_Query",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "moduleRating_Query",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "b4d54d34d4aef6ed6fa037459e227628",
    "id": null,
    "metadata": {},
    "name": "moduleRating_Query",
    "operationKind": "query",
    "text": "query moduleRating_Query(\n  $nodeRef: ID!\n) {\n  ModuleRating {\n    GetModuleRatingOptByNodeAndUserRef(nodeRef: $nodeRef) {\n      id\n      value\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "2f959cfbfbaef3316762df3c79d6f23c";

export default node;
